import { render, staticRenderFns } from "./Resolucion.vue?vue&type=template&id=2b0c4680"
import script from "./Resolucion.vue?vue&type=script&lang=js"
export * from "./Resolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports